class CustomEventService {
  constructor() {
    this.callbacks = {};
  }

  getEvents = () => {
    return this.callbacks;
  }

  /**
   * @param {string} eventName
   * @param {*} data
   */
  triggerEvent = (eventName, data = null) => {
    if (this.callbacks[eventName]) {
      if (data !== null) {
        this.callbacks[eventName].callbackFn(data);
      } else {
        this.callbacks[eventName].callbackFn.apply(null, this.callbacks[eventName].arguments);
      }
      // Object.keys(this.callbacks[eventName]).forEach((id) => {
      //   this.callbacks[eventName][id](data);
      // });
    }
  }

  /**
   * @param {string} eventName name of event
   * @param {Function} callback
   * @param {Array} params callback parameters
   */
  listenEvent = (eventName, callback, params = []) => {
    this.callbacks[eventName] = {};
    this.callbacks[eventName].callbackFn = callback;
    this.callbacks[eventName].arguments = params;
  }

  /**
   * @param {string} eventName name of event
   */
  unlistenEvent = (eventName) => {
    delete this.callbacks[eventName];
  }
}

let instance = new CustomEventService();
export default instance;



// WEBPACK FOOTER //
// ../q-jobs/src/utils/CustomEventService/index.js